export default __webpack_public_path__ + "static/media/RAV4New_Car_Lora_Thumb.a48edde3.jpg";